import React, {
    useState,
    useEffect
} from 'react';

import {
    BrowserRouter as Router,
    Redirect,
} from 'react-router-dom'

import moment from 'moment';

import {
    SearchOutlined,
} from '@ant-design/icons';

import {
    message,
    Form,
    Input,
    Popconfirm,
    DatePicker,
    InputNumber,
    Divider,
    Button,
    Table
} from "antd"

import {
    db,
    storr
} from '../firebase/firebase'

const EditableCell = ({
    editing,
    dataIndex,
    title,
    inputType,
    record,
    index,
    children,
    ...restProps
}) => {
    const inputNode = inputType === 'number' ? <InputNumber /> : <Input />;
    return (
        <td {...restProps}>
            {editing ? (
                <Form.Item
                    name={dataIndex}
                    style={{
                        margin: 0,
                    }}
                    rules={[
                        {
                            required: true,
                            message: `Please Input ${title}!`,
                        },
                    ]}
                >
                    {inputNode}
                </Form.Item>
            ) : (
                children
            )}
        </td>
    );
};

const COLLECTION_NAME = "promotions"
const HEADING = "Promotions"

const Promotions = (props) => {
    useEffect(() => {
        pullFromDB()
    }, []);

    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [editingKey, setEditingKey] = useState('');
    const [pendingData, setPendingData] = useState({ disabled: true, inputDisabled: false });
    const [disabled, setDisabled] = useState(true);

    const [addingTodo, setAddingTodo] = useState('');
    const [addingEvent, setAddingEvent] = useState(false);
    const [pendingTitle, setPendingTitle] = useState('');
    const [pendingDate, setPendingDate] = useState(moment());
    const [projectName, setProjectName] = useState('');
    const [invalidPage, setInvalidPage] = useState(false);

    const isEditing = (record) => record.key === editingKey;

    const edit = (record) => {
        form.setFieldsValue({
            filename: '',
            ...record,
        });
        setEditingKey(record.key);
    };

    const cancel = () => {
        setEditingKey('');
    };

    const save = async (key) => {
        try {
            const row = await form.validateFields();
            const newData = [...data];
            const index = newData.findIndex((item) => key === item.key);

            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, { ...item, ...row });

                try {

                    await db
                        .collection(COLLECTION_NAME)
                        .doc(data[index].id).update({
                            //to do in the future: maybe convert the user editted date into isostring format, so can store together
                            // date: this.state.da,
                            title: newData[index].title
                        })
                    message.success("Event " + newData[index].filename + " successfully updated!");
                    setData(newData)
                    setEditingKey('');

                } catch (error) {
                    message.error(error.message);

                }

            } else {
                newData.push(row);
                setData(newData);
                setEditingKey('');
            }
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    }

    const toLocalTime = (ts) => {
        var dt = new Date(ts).toLocaleString();
        return dt
    }

    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({
            setSelectedKeys, selectedKeys, confirm, clearFilters,
        }) => (
            <div style={{ padding: 8 }}>
                <Input
                    ref={node => { this.searchInput = node; }}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => handleSearch(selectedKeys, confirm)}
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Search
                </Button>
                <Button
                    onClick={() => handleReset(clearFilters)}
                    size="small"
                    style={{ width: 90 }}
                >
                    Reset
                </Button>
            </div>
        ),
        filterIcon: filtered => <SearchOutlined />,
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
                setTimeout(() => this.searchInput.select());
            }
        },
        render: (text) => (
            text
        ),
    })
    const pullFromDB = async () => {

        let projectID = props.match.params.id

        let project = await db.collection("projects").doc(projectID).get()

        if (!project.exists) {
            alert('invalid page')
            setInvalidPage(true)
            return
        }
        
        setProjectName(project.data().name)

        // We listen for live changes to our data collection in Firebase
        db.collection(COLLECTION_NAME).where("project", "==", projectID).onSnapshot(snapshot => {
            //data is locally available array, pulled from firestore.
            let data = [];
            snapshot.forEach(doc => {
                const todo = doc.data();
                todo.id = doc.id;
                todo.datestring = moment(todo.date).toLocaleString()
                data.push(todo);
            });

            // Sort our data based on time added
            data.sort(function (a, b) {
                return (
                    new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
                );
            });

            //assign primary key
            for (var i = 0; i < data.length; i++) {
                data[i].key = i;
            }
            console.log(data);

            setData(data)

        })
        // var ref = db.collection(COLLECTION_NAME).doc(this.props.match.params.id)
        // ref.get().then((doc) => {

        //     this.setState({
        //         master: doc.data(),
        //     });
        //     this.handleChange();
        // })


    }
    const columns = [
        {
            title: 'Date',
            dataIndex: 'date',
            ...getColumnSearchProps('datestring'),
            sorter: (a, b) => { return a.date.localeCompare(b.date) },
            render: (_, record) => {
                return (
                    record.datestring
                )
            }
        },
        {
            title: 'Title',
            dataIndex: 'title',
            editable: true,
            ...getColumnSearchProps('title'),
            sorter: (a, b) => { return a.title.localeCompare(b.title) },
        },
        {
            title: 'Image',
            dataIndex: 'link',
            editable: false,
            render: (text, record) => {
                return (
                    <div>
                        <a href={record.link} target="_blank">
                            <img src={record.link} alt="" height='150' />
                        </a>
                    </div>
                );
            },
        },
        {
            title: '',
            width: '20%',
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
                        <Button
                            href=""
                            onClick={e => {
                                e.preventDefault()
                                save(record.key)
                            }}
                            style={{
                                marginRight: 8,
                            }}
                        >
                            Save
                        </Button>
                        <Button type="primary" onClick={() => cancel(record.key)}>Cancel</Button>
                    </span>
                ) : (
                    <div>
                        <Button disabled={editingKey !== ''} onClick={() => edit(record)}>
                            Edit
                        </Button>
                        <Divider type="vertical" />

                        <Popconfirm
                            title="Confirm Delete?"
                            onConfirm={evt => deleteProject(record.key)}
                        >
                            <Button
                                type="danger"
                            >
                                Delete
                            </Button>
                        </Popconfirm>

                    </div>
                );
            },
        },
    ];

    const handleSearch = (selectedKeys, confirm) => {
        confirm();
    }

    const handleReset = (clearFilters) => {
        clearFilters();
    }

    const handleChange = (e) => {
        setPendingDate(e)
        console.log(pendingDate)
    }

    const addEntry = () => {

        if (pendingData.file != null) {
            var tempC = pendingData
            tempC.inputDisabled = true
            tempC.disabled = true
            setPendingData(tempC)

            uploadThenAddToDatabase(pendingData)
        } else {
            message.error("Something wrong happened, no file was in it")
        }
    }

    const uploadThenAddToDatabase = async (ahh) => {

        message.loading('Uploading...')
        console.log(JSON.stringify(ahh))
        let projectID = props.match.params.id

        var docy = db.collection(COLLECTION_NAME).doc()

        var refy = storr.ref(docy.id + ahh.file.name.substring(ahh.file.name.lastIndexOf('.'), ahh.file.name.length));

        await refy.put(ahh.file)
        let url = await refy.getDownloadURL()


        await docy.set({
            date: pendingDate.valueOf(),
            filename: ahh.file.name,
            title: pendingTitle,
            link: url,
            project: projectID,
        })

        if (document.getElementById("uploadCaptureInputFile"))
            document.getElementById("uploadCaptureInputFile").value = ""

        ahh.file = null
        ahh.inputDisabled = false
        ahh.disabled = true
        setPendingData(ahh)
        setDisabled(true)
        message.destroy()
        message.success("Uploaded successfully")
    }

    const clearInputFile = () => {
        var tempB = pendingData
        document.getElementById("uploadCaptureInputFile").value = ""
        tempB.file = null
        tempB.disabled = true
        setPendingData(tempB)
        setDisabled(tempB.disabled)
    }

    const deleteProject = async (id) => {
        var fn = data[id].filename
        var idea = data[id].id

        var ext = fn.substring(fn.lastIndexOf('.'), fn.length)

        await db
            .collection(COLLECTION_NAME)
            .doc(idea)
            .delete().then(function () {
                message.success("Row deleted successfully")
                var ref = storr.ref(idea + ext);
                // Get the download URL
                ref.delete().then(function () {
                    message.success("File " + fn + " deleted successfully")
                }).catch(function (error) {
                    message.error(error.message)
                });
            }).catch(function (error) {
                message.error(error.message)
            });
    }

    const handlePreuploadFile = (event) => {

        var abb = pendingData;

        var whitelistedFormats = ["image/png", "image/jpeg"];
        var acceptedFileFormat = whitelistedFormats.includes(event.target.files[0].type)

        if (event.target.files[0]) {
            if (acceptedFileFormat) {
                console.log("accepted file format")
                if (event.target.files[0].size < 100000000) {
                    abb.disabled = false
                    message.info("You inputed " + event.target.files[0].name)
                    abb.file = event.target.files[0]
                } else {
                    message.error("File is too big");
                    event.target.value = ""
                    abb.file = null
                    abb.disabled = true
                }
            } else {
                message.error("Not the accepted file type");
                event.target.value = ""
                abb.file = null
                abb.disabled = true
            }
        } else {
            message.error("No file in it");
            event.target.value = ""
            abb.file = null
            abb.disabled = true
        }
        setPendingData(abb)
        setDisabled(abb.disabled)
    }

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }

        return {
            ...col,
            onCell: (record) => ({
                record,
                inputType: col.dataIndex === 'age' ? 'number' : 'text',
                dataIndex: col.dataIndex,
                title: col.title,
                editing: isEditing(record),
            }),
        };
    });
    return (
        <div>
            {invalidPage ?
                <Redirect to='/dashboard' />
                :
                <div />
            }

            <h1>{projectName} {HEADING}</h1>

            <br></br>
            <div className="gutter-box">
                <DatePicker
                    size="large"
                    className="margin-row"
                    format="DD-MM-YYYY"
                    disabled={addingTodo}
                    selected={pendingDate}
                    onChange={handleChange}
                    value={pendingDate}
                />
            </div>
            <div className="gutter-box">
                <Input
                    className="gutter-box"
                    size="large"
                    placeholder="Title"
                    disabled={addingEvent}
                    onInput={evt => setPendingTitle(evt.target.value)}
                    value={pendingTitle}
                    required
                />
            </div>
            {!disabled &&
                <div className="gutter-box">
                    <Button
                        type="danger"
                        onClick={clearInputFile}
                        disabled={pendingData.inputDisabled}
                        ghost
                    >
                        Clear file
                    </Button>
                </div>
            }
            <input type="file"
                id="uploadCaptureInputFile"
                accept="image/*"
                onChange={handlePreuploadFile}
                disabled={pendingData.inputDisabled}
            />
            <div className="gutter-box">
                <Button
                    className="inputt App-add-todo-button"
                    size="large"
                    type="primary"
                    onClick={addEntry}
                    disabled={disabled}
                >
                    Add Image
                </Button>
            </div>
            <Form form={form} component={false}>
                <Table
                    components={{
                        body: {
                            cell: EditableCell,
                        },
                    }}
                    bordered
                    dataSource={data}
                    columns={mergedColumns}
                    rowClassName="editable-row"
                    pagination={{
                        onChange: cancel,
                    }}
                />
            </Form>
        </div>
    );
};

export default Promotions;



// WEBPACK FOOTER //
// ./src/views/promotions.js